<div class="body">

    <div class="icon">

        <span class="fiv-sqo file-icon" [ngClass]="icon"></span>

    </div>

    <div class="filename">
        {{file.localName}}
    </div>

</div>